import { OrganizationMembership } from "@/api";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from "@/components/ui/select";
import { useEffect } from "react";

interface Props {
  memberships: OrganizationMembership[];
  setSelectedOrganizationSlug: (slug: string | undefined) => void;
}

function OrganizationSelect({
  memberships,
  setSelectedOrganizationSlug
}: Props) {
  const disableSelect = memberships.length < 2;
  const defaultValue =
    memberships.length === 1 ? memberships[0].organization.id : undefined;

  const handleValueChange = (organizationId: string) => {
    const slug = memberships.find(
      (membership) => membership.organization.id === organizationId
    )?.organization.slug;
    setSelectedOrganizationSlug(slug);
  };

  useEffect(() => {
    if (memberships.length === 1) {
      setSelectedOrganizationSlug(memberships[0].organization.slug);
    }
  }, [memberships, setSelectedOrganizationSlug]);

  return (
    <Select
      name="organization"
      required
      defaultValue={defaultValue}
      onValueChange={handleValueChange}
    >
      <SelectTrigger
        disabled={disableSelect}
        data-testid="organizationSelect"
        defaultValue={defaultValue}
      >
        <SelectValue placeholder="Select an organization" />
      </SelectTrigger>
      <SelectContent>
        {memberships.map((membership) => (
          <SelectItem
            key={membership.organization.id}
            value={membership.organization.id}
            data-testid="organizationItem"
          >
            {membership.organization.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}

export default OrganizationSelect;
